<template>
    <client-page class=" wrap--products">
        <div class="container">
            <h2 class="join-title">회원가입</h2>

            <div class="join-container">
                <!-- 가입 단계 표시 -->
                <nav class="join-step">
                    <ul class="join-step-lists">
                        <li class="list list--on">
                            <span class="badge">STEP 1</span>
                            <span class="text">약관동의</span>
                        </li>
                        <li class="list list--on">
                            <span class="badge">STEP 2</span>
                            <span class="text">정보입력</span>
                        </li>
                        <li class="list list--on">
                            <span class="badge">STEP 3</span>
                            <span class="text">가입완료</span>
                        </li>
                    </ul>
                </nav>

                <div class="join-complate">
                    <i class="icon icon-handshake"></i>
                    <h3 class="join-complate__title">회원가입이 완료 되었습니다.</h3>
                    <p class="join-complate__text mt-8 mt-md-14">가입해 주셔서 감사합니다.</p>
                </div>

                <!-- 하단버튼 -->
                <div class="bottom-button">
                    <div class="v-btn--group v-btn--group--large">
                        <v-btn x-large color="primary" to="/" class="w-100 mw-220px">시작하기</v-btn>
                    </div>
                </div>
            </div>
        </div>
	</client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";

export default{
	components: {
		ClientPage,
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>
